__turbopack_context__.v({
  "body": "style-module-scss-module__0vbIBq__body",
  "container": "style-module-scss-module__0vbIBq__container",
  "header": "style-module-scss-module__0vbIBq__header",
  "links": "style-module-scss-module__0vbIBq__links",
  "logoWrapper": "style-module-scss-module__0vbIBq__logoWrapper",
});
